import { MainPadding } from "../../../styles/Main.styles";
import { useState } from "react";
import TableHeader from "../../../components/table/TableHeader";
import { useNavigate } from "react-router";
import TableFC, {
  TableFCBodyProps,
  TableHeadProps,
} from "../../../components/table/Table";
import { useGetCategory } from "../../produk/api/product/category/resolver";
import useTableProperties from "../__component/table/TableProperties";
import { IconOnButton } from "../../../components/button/Button";
import ImportExportIcon from "@mui/icons-material/ImportExport";

export default function Main() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState<string>();
  const [perPage, setPerPage] = useState(10);
  const { data: dataRawCategories, isLoading: loadingFetchSupplier } =
    useGetCategory({ page, keyword });
  const dataCategories = dataRawCategories?.data.data.data;
  const { renderRight } = useTableProperties();
  const header: TableHeadProps[] = [{ title: "No" }, { title: "Nama" }];
  const body: TableFCBodyProps[] = [{ key: "category_name" }];

  return (
    <MainPadding>
      <TableHeader
        addButton
        onClickAdd={() => navigate("/kategori/creation")}
        renderRight={renderRight()}
        searchBar
        onSearch={(e) => setKeyword(e)}
        filterLabel="Search Kategori"
        renderRightButton={
          <IconOnButton
            text="Import/Export"
            icon={<ImportExportIcon />}
            handleClick={() => {}}
          />
        }
      />
      <TableFC
        loading={loadingFetchSupplier}
        data={dataCategories}
        body={body}
        showIndex
        totalRows={dataRawCategories?.data.data.total}
        perColumns={perPage}
        onPerPageChange={(e) => setPerPage(e)}
        head={header}
        onPageChange={(e) => setPage(e)}
        onCellClick={(e) => navigate(`/kategori/creation/${e.id}`)}
      />
    </MainPadding>
  );
}
